<template>
  <div
    class="d-flex flex-column ga-2 mt-4"
  >
    <DpplNewButton
      class="w-100"
      color="primary"
      size="small"
      :disabled="disabled"
      @click="$emit('share-via-email')"
    >
      {{ shareViaEmailText }}
    </DpplNewButton>
    <div class="w-100 d-flex ga-2">
      <DpplNewButton
        class="w-50"
        color="primary"
        size="small"
        variant="outlined"
        :disabled="disabled"
        @click="$emit('share-via-image')"
      >
        {{ shareViaImageText }}
      </DpplNewButton>
      <DpplNewButton
        class="w-50"
        color="primary"
        size="small"
        variant="outlined"
        @click="emit('copy-report-link')"
      >
        Copy Report Link
      </DpplNewButton>
    </div>
  </div>
</template>

<script setup>
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';

defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  shareViaEmailText: {
    type: String,
    default: 'Share via Email',
  },
  shareViaImageText: {
    type: String,
    default: 'Email Report Image',
  },
});

const emit = defineEmits(['copy-report-link', 'share-via-email', 'share-via-image']);
</script>
